export const translations = {
  fr: {
    nav_home: "Accueil",
    nav_services: "Services",
    nav_book: "Réserver",
    nav_login: "Connexion",
    nav_dashboard: "Tableau de bord",
    nav_logout: "Déconnexion",
    hero_cta: "Réserver un tournage",
    services_title: "Nos services",
    services_sub: "Combinez les prestations ou choisissez une spécialité.",
    book_step_1: "Propriété",
    book_step_2: "Services",
    book_step_3: "Style de votre vidéo",
    book_step_4: "Date & heure",
    book_step_5: "Coordonnées",
    book_step_6: "Confirmation",
    property_address: "Adresse de la propriété",
    property_address_placeholder: "123 rue Principale, Ville, QC",
    property_area: "Superficie (pi²)",
    property_status: "Statut",
    status_occupied: "Occupée",
    status_vacant: "Vacante",
    access_mode: "Mode d'accès",
    access_keybox: "Boîte à clé",
    access_owner: "Propriétaire présent",
    access_broker: "Courtier présent",
    lockbox_code: "Code de la boîte à clé",
    lockbox_help: "Ex. : 1234. Précisez l'emplacement au besoin.",
    centris: "Numéro Centris (optionnel)",
    notes: "Notes additionnelles",
    continue: "Continuer",
    back: "Retour",
    choose_services: "Choisissez vos prestations",
    pick_date: "Choisissez la date",
    weather_forecast: "Météo prévue",
    sunset: "Coucher du soleil",
    drone_warning: "Vent fort — risque pour le drone",
    rain_warning: "Pluie prévue",
    sunset_warning: "La séance se termine après le coucher du soleil",
    pick_slot: "Choisissez l'heure",
    no_slots: "Aucun créneau disponible — essayez une autre date.",
    contact_info: "Vos coordonnées",
    full_name: "Nom complet",
    first_name: "Prénom",
    last_name: "Nom",
    email: "Courriel",
    phone: "Téléphone",
    confirm_booking: "Confirmer la réservation",
    booking_confirmed: "Réservation confirmée!",
    summary: "Récapitulatif",
    services: "Services",
    duration: "Durée totale",
    date: "Date",
    travel_distance: "Distance aller simple",
    travel_fee: "Frais de déplacement",
    total: "Total",
    travel_included: "60 km aller-retour inclus",
    minutes: "min",
    km: "km",
    language: "Langue",

    // Landing / accueil
    landing_eyebrow: "Mise en marché immobilière professionnelle",
    landing_regions: "Rive-Nord · Laval · Montréal · Laurentides",
    landing_paragraph: "Photos immobilières, vidéo cinématique, drone 4K, prise de mesures et plans 2D. Réservez en ligne. Nous calculons automatiquement le temps prévu au rendez-vous.",
    landing_cta: "Prendre rendez-vous",
    landing_stat_value: "+ de 1 Md $",
    landing_stat_desc: "en valeur de propriétés mises en marché",
    landing_from: "À partir de",
    landing_travel_note: "Sans frais de déplacement pour toutes les inscriptions situées dans un rayon de 30 km de notre bureau de Ste-Thérèse. 1 $/km au-delà de cette distance.",
    faq_title: "Questions fréquentes",
    landing_faq: [
      ["Combien coûte une séance de photos immobilières?", "De {photo_min} à {photo_max} avant taxes, selon le nombre de photos (20 à 50). Les retouches sont incluses. Photo excédentaire : {extra_photo} chacune."],
      ["Combien coûte une vidéo immobilière?", "De {video_min} à {video_max} avant taxes. Chaque vidéo inclut un montage de 1 min 30, un plan créé par intelligence artificielle et un tour de correction. Les prises de vues par drone sont incluses seulement avec le combo photos + vidéo. {evening}"],
      ["Quels secteurs desservez-vous?", "La Rive-Nord, Laval, Montréal et les Laurentides. Le déplacement est inclus jusqu'à 30 km de notre bureau de Sainte-Thérèse. Ensuite, c'est 1 $ par kilomètre."],
      ["En combien de temps les photos sont-elles livrées?", "{photos_eta}. Une livraison plus rapide est offerte pour {rush_fee} de plus."],
      ["Faut-il payer à la réservation?", "Non. Vous payez en ligne dès la livraison de vos premiers fichiers. Le paiement débloque le téléchargement de tout votre projet, y compris ce qui sera livré ensuite."],
      ["Puis-je modifier mon rendez-vous?", "Oui, vous pouvez le modifier ou l'annuler vous-même en ligne jusqu'à 48 h avant."],
      ["Offrez-vous la prise de mesures et les plans 2D?", "Oui. Ajoutez-les à votre forfait photos pour {plans_price}, ou obtenez-les gratuitement avec le combo photos + vidéo (photos drone incluses aussi)."],
      ["Les photos drone sont-elles incluses?", "Les photos drone sont à {drone_price} avec une séance photo et à {drone_alone} seules (jusqu'à 10 photos aériennes). Elles sont incluses gratuitement seulement avec le combo photos + vidéo."],
      ["Puis-je avoir la vidéo en vertical et en horizontal?", "Oui. La version verticale ajoutée coûte {both_formats} : la vidéo est tournée à l'horizontale, puis recadrée en version verticale. Une vidéo verticale ne peut pas être livrée à l'horizontale."],
    ],

    // Booking wizard
    err_address: "Adresse requise",
    err_onsite_contact: "Indiquez le nom et le téléphone de la personne sur place.",
    coords_link: "Adresse introuvable ? Entrez les coordonnées",
    coords_label: "Latitude, longitude",
    coords_help: "Copiez les coordonnées depuis Centris ou Google Maps (clic droit sur l'emplacement).",
    coords_apply: "Placer l'épingle",
    coords_invalid: "Entrez les coordonnées sous la forme 45.6612, -73.8394.",
    coords_not_qc: "Ces coordonnées ne semblent pas au Québec. Vérifiez-les.",
    location_desc: "Description de l'emplacement",
    location_desc_ph: "Ex. : Lot 23, rue de l'Épine, en construction, Mirabel",
    err_location_desc: "Ajoutez une description de l'emplacement.",
    directions_note: "Indications pour se rendre (optionnel)",
    directions_note_ph: "Ex. : Maison modèle, lot 23, entrée par la rue des Pins",
    onsite_contact: "Nom et téléphone de la personne sur place",
    onsite_contact_ph: "Ex. : Marie Tremblay, (514) 555-0199",
    onsite_contact_help: "Visible seulement par notre équipe. Jamais envoyé par texto.",
    err_address_pick: "Choisissez votre adresse dans la liste pour que nous puissions calculer les frais de déplacement.",
    addr_checking: "Validation de l'adresse…",
    addr_pick_failed: "Nous n'avons pas pu récupérer cette adresse. Réessayez.",
    err_service: "Choisissez au moins un service",
    err_tier: "Choisissez une formule pour chaque service sélectionné.",
    err_slot: "Choisissez un créneau",
    err_contact: "Coordonnées requises",
    err_generic: "Erreur",
    promo_need_email: "Entrez d'abord votre courriel.",
    promo_label: "Code promo",
    promo_remove: "Retirer",
    promo_apply: "Appliquer",
    promo_applied_prefix: "✓ Code",
    promo_applied_mid: "appliqué · Rabais de",
    promo_floor_note: "(ajusté au prix plancher)",
    promo_discount_label: "Rabais",
    promo_banner_applied: "Rabais de {amount} $ appliqué",
    trip_duration: "Durée trajet",
    travel_fee_line: "Frais de déplacement : {fee}",
    travel_detail: "Votre propriété est à {km} km de notre bureau de Sainte-Thérèse. Les {inc} premiers kilomètres sont inclus, à l'aller comme au retour. Ensuite, {rate} par kilomètre.",
    travel_free: "Déplacement inclus",
    onsite_time: "Temps prévu sur place : {dur}",
    onsite_note: "Assurez-vous que la propriété est prête et accessible pendant toute cette période.",
    onsite_card: "{dur} sur place",
    about: "environ",
    not_ready_label: "Propriété non prête à l'arrivée",
    not_ready_comment: "Commentaire (état des lieux, délai, etc.)",
    not_ready_save: "Signaler",
    not_ready_clear: "Retirer le signalement",
    not_ready_by: "Signalé par",
    proof_since: "Depuis 2011",
    proof_since_rest: "au service des courtiers",
    proof_amount: "+ de 1 milliard $",
    proof_amount_rest: "en propriétés mises en marché",
    proof_rating: "4,9 ★",
    proof_google: "sur Google",
    recommended: "Recommandé",
    choose_tier: "Choisissez votre forfait",
    combo_photos_opt: "Nombre de photos",
    combo_switched: "Photos et vidéo réservées ensemble : nous avons appliqué le prix du combo.",
    extra_photo_note: "Photo excédentaire : {price} chacune, au-delà du forfait choisi.",
    addr_unvalidated: "Nous n'avons pas pu valider cette adresse. Vérifiez-la, les frais de déplacement en dépendent.",
    addr_validated: "Adresse validée",
    subtotal: "Sous-total",
    gst: "TPS",
    qst: "TVQ",
    tax_numbers: "N° TPS {gst} · N° TVQ {qst}",
    running_total: "Total avant taxes",
    invoice_lines: "Lignes ajoutées",
    add_line: "Ajouter une ligne à la facture",
    line_label: "Description",
    line_amount: "Montant (+ ou −)",
    journal: "Journal",
    addr_flag_team: "Adresse non validée par le client — vérifier les frais de déplacement",
    svc_from: "À partir de",
    rain_label: "pluie",
    confirm_email_sent: "Un courriel de confirmation a été envoyé à",
    confirm_reference: "Référence",
    back_home: "Retour à l'accueil",

    // Gallery
    gallery_caption: "Galerie",
    gallery_status: "Statut",
    gallery_upload: "Téléverser photo/vidéo",
    gallery_uploading: "Téléversement…",
    gallery_uploaded: "Fichier téléversé",
    gallery_upload_err: "Erreur téléversement",
    gallery_approve_prompt: "Votre nom pour l'approbation:",
    gallery_revision_prompt: "Votre commentaire de modification:",
    gallery_approved: "Approuvé",
    gallery_revision_sent: "Demande envoyée",
    gallery_download: "Télécharger",
    gallery_empty: "Aucun fichier encore.",
    gallery_request_revision: "Demander une modification",
    gallery_approve: "Approuver",
    gallery_pay: "Payer pour télécharger",
    gallery_paid: "Paiement confirmé!",
    gallery_videos: "vidéo(s)",
    gallery_deliver_confirm: "Confirmez la livraison de ce livrable au courtier :",
    gallery_delivered: "Livrable livré",
    gallery_deliver: "Livrer",
    gallery_deliver_to_broker: "Livrer au courtier",
    gallery_dropzone_title: "Glissez-déposez vos fichiers ici",
    gallery_dropzone_hint: "ou cliquez pour parcourir",
    gallery_delete: "Supprimer",
    gallery_delete_confirm: "Supprimer ce fichier ? Cette action est définitive.",
    gallery_invoice: "Facture du projet",
    gallery_pay_now: "Payer maintenant",
    gallery_status_delivered: "Livré",
    gallery_status_production: "En production",
    gallery_coming_soon: "Votre livrable « {label} » sera disponible ici dès qu'il sera prêt. Vous recevrez un texto et un courriel avec le lien.",
    gallery_processing: "Traitement…",
    gallery_report_prompt: "Décrivez le problème (défaut) :",
    gallery_report_sent: "Problème signalé",
    gallery_report_problem: "Signaler un problème",
    gallery_extra_round: "Demander une ronde supplémentaire",
    gallery_extra_round_confirm: "Cette ronde supplémentaire est payante ({fee} + taxes). Continuer vers le paiement ?",
    gallery_included_round: "1 ronde de correction incluse.",
    gallery_until: "Disponible jusqu'au",
    gallery_revision_placeholder: "Regroupez toutes vos demandes de correction en un seul message…",
    gallery_confirm_text: "Cette demande utilise votre ronde de correction incluse. Les demandes suivantes seront facturées 50 $. Avez-vous inscrit tous vos changements ?",
    gallery_review_request: "Revoir ma demande",
    gallery_confirm_send: "Confirmer et envoyer",
    gallery_proj_in_production: "En production",
    gallery_proj_awaiting_payment: "En attente de paiement",
    gallery_proj_paid: "Payé",
  },
  en: {
    nav_home: "Home",
    nav_services: "Services",
    nav_book: "Book",
    nav_login: "Sign in",
    nav_dashboard: "Dashboard",
    nav_logout: "Sign out",
    hero_cta: "Book a shoot",
    services_title: "Our services",
    services_sub: "Combine services or pick a specialty.",
    book_step_1: "Property",
    book_step_2: "Services",
    book_step_3: "Your video style",
    book_step_4: "Date & time",
    book_step_5: "Contact",
    book_step_6: "Confirmation",
    property_address: "Property address",
    property_address_placeholder: "123 Main St, City, QC",
    property_area: "Area (sqft)",
    property_status: "Status",
    status_occupied: "Occupied",
    status_vacant: "Vacant",
    access_mode: "Access mode",
    access_keybox: "Lockbox",
    access_owner: "Owner on site",
    access_broker: "Broker on site",
    lockbox_code: "Lockbox code",
    lockbox_help: "e.g. 1234. Add the location if needed.",
    centris: "Centris number (optional)",
    notes: "Additional notes",
    continue: "Continue",
    back: "Back",
    choose_services: "Choose your services",
    pick_date: "Pick the date",
    weather_forecast: "Weather forecast",
    sunset: "Sunset",
    drone_warning: "Strong winds — drone risk",
    rain_warning: "Rain expected",
    sunset_warning: "Shoot ends after sunset",
    pick_slot: "Pick a time",
    no_slots: "No slots available — try another date.",
    contact_info: "Your contact info",
    full_name: "Full name",
    first_name: "First name",
    last_name: "Last name",
    email: "Email",
    phone: "Phone",
    confirm_booking: "Confirm booking",
    booking_confirmed: "Booking confirmed!",
    summary: "Summary",
    services: "Services",
    duration: "Total duration",
    date: "Date",
    travel_distance: "One-way distance",
    travel_fee: "Travel fee",
    total: "Total",
    travel_included: "60 km round-trip included",
    minutes: "min",
    km: "km",
    language: "Language",

    // Landing
    landing_eyebrow: "Professional real estate marketing",
    landing_regions: "North Shore · Laval · Montreal · Laurentians",
    landing_paragraph: "Real estate photos, cinematic video, 4K drone, measurements and 2D floor plans. Book online. We automatically calculate the time needed for your appointment.",
    landing_cta: "Book an appointment",
    landing_stat_value: "Over $1B",
    landing_stat_desc: "in properties marketed",
    landing_from: "From",
    landing_travel_note: "No travel fees for all listings within a 30 km radius of our Ste-Thérèse office. $1/km beyond that distance.",
    faq_title: "Frequently asked questions",
    landing_faq: [
      ["How much does a real estate photo session cost?", "From {photo_min} to {photo_max} before taxes, depending on the number of photos (20 to 50). Retouching is included. Extra photo: {extra_photo} each."],
      ["How much does a real estate video cost?", "From {video_min} to {video_max} before taxes. Each video includes a 1 min 30 edit, one AI-generated shot and one round of revisions. Drone footage is included only with the photos + video combo. {evening}"],
      ["Which areas do you serve?", "The North Shore, Laval, Montreal and the Laurentians. Travel is included up to 30 km from our Sainte-Thérèse office. Beyond that, it's $1 per kilometer."],
      ["How quickly are photos delivered?", "{photos_eta}. Faster delivery is available for an extra {rush_fee}."],
      ["Do I have to pay when booking?", "No. You pay online as soon as your first files are delivered. Payment unlocks the download of your whole project, including anything delivered afterwards."],
      ["Can I change my appointment?", "Yes, you can change or cancel it yourself online up to 48 h before."],
      ["Do you offer measurements and 2D floor plans?", "Yes. Add them to your photo package for {plans_price}, or get them free with the photos + video combo (drone photos included too)."],
      ["Are drone photos included?", "Drone photos are {drone_price} with a photo session and {drone_alone} on their own (up to 10 aerial photos). They are free only with the photos + video combo."],
      ["Can I get the video in both vertical and horizontal?", "Yes. The added vertical version costs {both_formats}: the video is shot horizontally, then cropped to a vertical version. A vertical video cannot be delivered horizontally."],
    ],

    // Booking wizard
    err_address: "Address required",
    err_onsite_contact: "Please provide the name and phone of the person on site.",
    coords_link: "Address not found? Enter the coordinates",
    coords_label: "Latitude, longitude",
    coords_help: "Copy the coordinates from Centris or Google Maps (right-click on the location).",
    coords_apply: "Place the pin",
    coords_invalid: "Enter coordinates like 45.6612, -73.8394.",
    coords_not_qc: "These coordinates do not seem to be in Quebec. Please check them.",
    location_desc: "Location description",
    location_desc_ph: "e.g. Lot 23, rue de l'Épine, under construction, Mirabel",
    err_location_desc: "Please add a location description.",
    directions_note: "How to get there (optional)",
    directions_note_ph: "e.g. Model home, lot 23, entrance on rue des Pins",
    onsite_contact: "Name and phone of the person on site",
    onsite_contact_ph: "e.g. Marie Tremblay, (514) 555-0199",
    onsite_contact_help: "Visible to our team only. Never sent by text message.",
    err_address_pick: "Please pick your address from the list so we can calculate travel fees.",
    addr_checking: "Validating address…",
    addr_pick_failed: "We could not retrieve this address. Please try again.",
    err_service: "Choose at least one service",
    err_tier: "Please choose a package for each selected service.",
    err_slot: "Choose a time slot",
    err_contact: "Contact info required",
    err_generic: "Error",
    promo_need_email: "Enter your email first.",
    promo_label: "Promo code",
    promo_remove: "Remove",
    promo_apply: "Apply",
    promo_applied_prefix: "✓ Code",
    promo_applied_mid: "applied · Discount of",
    promo_floor_note: "(adjusted to floor price)",
    promo_discount_label: "Discount",
    promo_banner_applied: "Discount of ${amount} applied",
    trip_duration: "Trip duration",
    travel_fee_line: "Travel fee: {fee}",
    travel_detail: "Your property is {km} km from our Sainte-Thérèse office. The first {inc} kilometres are included, each way. Beyond that, {rate} per kilometre.",
    travel_free: "Travel included",
    onsite_time: "Planned time on site: {dur}",
    onsite_note: "Please make sure the property is ready and accessible for the whole period.",
    onsite_card: "{dur} on site",
    about: "about",
    not_ready_label: "Property not ready on arrival",
    not_ready_comment: "Comment (condition, delay, etc.)",
    not_ready_save: "Report",
    not_ready_clear: "Remove report",
    not_ready_by: "Reported by",
    proof_since: "Since 2011",
    proof_since_rest: "serving real estate agents",
    proof_amount: "Over $1 billion",
    proof_amount_rest: "in properties marketed",
    proof_rating: "4.9 ★",
    proof_google: "on Google",
    recommended: "Recommended",
    choose_tier: "Choose your package",
    combo_photos_opt: "Number of photos",
    combo_switched: "Photos and video booked together: combo pricing applied.",
    extra_photo_note: "Extra photo: {price} each, beyond the chosen package.",
    addr_unvalidated: "We could not validate this address. Please check it — travel fees depend on it.",
    addr_validated: "Address validated",
    subtotal: "Subtotal",
    gst: "GST",
    qst: "QST",
    tax_numbers: "GST no. {gst} · QST no. {qst}",
    running_total: "Total before taxes",
    invoice_lines: "Added lines",
    add_line: "Add a line to the invoice",
    line_label: "Description",
    line_amount: "Amount (+ or −)",
    journal: "Journal",
    addr_flag_team: "Address not validated by the client — check travel fees",
    svc_from: "Starting at",
    rain_label: "rain",
    confirm_email_sent: "A confirmation email has been sent to",
    confirm_reference: "Reference",
    back_home: "Back to home",

    // Gallery
    gallery_caption: "Gallery",
    gallery_status: "Status",
    gallery_upload: "Upload photo/video",
    gallery_uploading: "Uploading…",
    gallery_uploaded: "File uploaded",
    gallery_upload_err: "Upload error",
    gallery_approve_prompt: "Your name for approval:",
    gallery_revision_prompt: "Your revision comment:",
    gallery_approved: "Approved",
    gallery_revision_sent: "Request sent",
    gallery_download: "Download",
    gallery_empty: "No files yet.",
    gallery_request_revision: "Request a revision",
    gallery_approve: "Approve",
    gallery_pay: "Pay to download",
    gallery_paid: "Payment confirmed!",
    gallery_videos: "video(s)",
    gallery_deliver_confirm: "Confirm delivery of this deliverable to the broker:",
    gallery_delivered: "Deliverable delivered",
    gallery_deliver: "Deliver",
    gallery_deliver_to_broker: "Deliver to broker",
    gallery_dropzone_title: "Drag & drop your files here",
    gallery_dropzone_hint: "or click to browse",
    gallery_delete: "Delete",
    gallery_delete_confirm: "Delete this file? This cannot be undone.",
    gallery_invoice: "Project invoice",
    gallery_pay_now: "Pay now",
    gallery_status_delivered: "Delivered",
    gallery_status_production: "In production",
    gallery_coming_soon: "Your « {label} » deliverable will appear here as soon as it is ready. You will receive a text and an email with the link.",
    gallery_processing: "Processing…",
    gallery_report_prompt: "Describe the problem (defect):",
    gallery_report_sent: "Problem reported",
    gallery_report_problem: "Report a problem",
    gallery_extra_round: "Request an extra round",
    gallery_extra_round_confirm: "This extra round is paid ({fee} + taxes). Continue to payment?",
    gallery_included_round: "1 correction round included.",
    gallery_until: "Available until",
    gallery_revision_placeholder: "Group all your correction requests into a single message…",
    gallery_confirm_text: "This request uses your included correction round. Further requests will be charged $50. Have you entered all your changes?",
    gallery_review_request: "Review my request",
    gallery_confirm_send: "Confirm and send",
    gallery_proj_in_production: "In production",
    gallery_proj_awaiting_payment: "Awaiting payment",
    gallery_proj_paid: "Paid",
  },
};

export const t = (lang, key) => (translations[lang] && translations[lang][key]) || key;

// EN display-name overrides for DB-stored service names (keyed by service code)
const serviceNamesEn = {
  photo: "Real estate photography",
  video: "Real estate video",
  photo_video: "Photo + Video combo",
  drone: "Drone footage",
};
export const serviceName = (lang, service) =>
  (lang === "en" && serviceNamesEn[service.code]) || service.name;

